<template>
  <div v-if="loaded" class="project-layout">
    <app-header>
      <template #title>
        <stage-selector :project="project" :stage="stage"></stage-selector>
      </template>
      <template #actions>
        <save-status v-if="$route.name == 'projects.stage2.userstories'"></save-status>
        <ul v-if="members.length" class="team-members">
            <li :alt="member.name" v-for="member in otherMembers" :key="member.id">
                <img :alt="member.name" v-bind:src="getAvatar(member.id)">
            </li>
        </ul>
      </template>
    </app-header>

    <div class="layout-sidesheet row">
      <div class="col main-content d-flex flex-column">
        <ul id="horizontal-nav" class="nav nav-horizontal sticky-top" style="position: sticky">
          <router-link tag="li" class="nav-item" :to="{name: 'projects.stage2.overview'}">
              <a class="nav-link">Overview</a>
          </router-link>
          <router-link v-if="stage.user_story_doc_id" tag="li" class="nav-item" :to="{name: 'projects.stage2.deliverables', params: {user_story_doc_id: stage.user_story_doc_id, sprint_id: 'active'}}">
              <a class="nav-link">Deliverables</a>
          </router-link>
          <router-link tag="li" class="nav-item" :to="{name: 'projects.stage2.userstories'}">
              <a class="nav-link">Userstories</a>
          </router-link>
          <router-link tag="li" class="nav-item" :to="{name: 'projects.stage2.activity'}">
              <a class="nav-link">Activity</a>
          </router-link>
          <router-link tag="li" class="nav-item" :to="{name: 'projects.stage2.costing'}">
              <a class="nav-link">Costing</a>
          </router-link>
        </ul>
        <!-- /#horizontal-nav -->

        <component v-if="filterComponentForRoute" :is="filterComponentForRoute" ref="filtersDrawer"></component>
        <component v-if="viewOptionsComponentForRoute" :is="viewOptionsComponentForRoute" ref="viewOptionsDrawer"></component>
        <component v-if="exportOptionsComponentForRoute" :is="exportOptionsComponentForRoute" ref="exportOptionsDrawer"></component>
        <opportunity-drawer v-if="this.$route.name == 'projects.stage2.overview' && !this.project.is_full_budget" ref="opportunityDrawer"></opportunity-drawer>
        <convert-to-stage3-drawer v-if="this.$route.name == 'projects.stage2.overview' && this.project.is_full_budget" ref="convertToStage3Drawer"></convert-to-stage3-drawer>
        <sprint-drawer v-if="this.$route.name == 'projects.stage2.overview'" ref="sprintDrawer"></sprint-drawer>
        <edit-drawer v-if="this.$route.name == 'projects.stage2.overview'" ref="editDrawer"></edit-drawer>

        <router-view></router-view>
      </div>

      <div class="col-auto project-right-nav">
        <ul>
          <li v-if="filterComponentForRoute.length">
              <button type="button" :class="`btn ${filtersApplied == true ? 'filter-active' : ''}`" @click="openDrawer('filtersDrawer')">
                  <i class="far fa-filter"></i>
              </button>
          </li>
          <li v-if="viewOptionsComponentForRoute.length">
              <button type="button" class="btn" @click="openDrawer('viewOptionsDrawer')">
                  <i class="far fa-eye"></i>
              </button>
          </li>
          <li v-if="exportOptionsComponentForRoute.length">
              <button type="button" class="btn" @click="openDrawer('exportOptionsDrawer')">
                  <i class="far fa-file-export"></i>
              </button>
          </li>
          <li v-if="this.$route.name == 'projects.stage2.overview' && !this.project.is_full_budget">
              <button type="button" class="btn" @click="openDrawer('opportunityDrawer')">
                  <i class="far fa-file-edit"></i>
              </button>
          </li>
          <li v-if="this.$route.name == 'projects.stage2.overview' && this.project.is_full_budget">
              <button type="button" class="btn" @click="openDrawer('convertToStage3Drawer')">
                  <i class="far fa-file-edit"></i>
              </button>
          </li>
          <li v-if="this.$route.name == 'projects.stage2.overview'">
              <button type="button" class="btn" @click="openDrawer('editDrawer')">
                  <i class="far fa-edit"></i>
              </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

    import { http } from 'utils'
    import { filters } from 'mixins'
    import EditDrawer from './project/stage/EditDrawer'
    import SprintDrawer from './project/SprintDrawer'
    import stageSelector from './_stage-selector'
    import SaveStatus from '../misc/SaveStatus'
    import { findIndex, find } from 'lodash'
    import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
    import { ADD_EPIC, ADD_USERSTORY, REMOVE_USERSTORY, SET_USERSTORY_PROPERTY } from 'vx/mutations'
    import { UserstoryFiltersDrawer, UserstoryViewOptionsDrawer, UserstoryExportOptionsDrawer, OpportunityDrawer, ConvertToStage3Drawer } from './project/stage2'
    import { echo } from 'mixins'

    export default {
        mixins: [filters, echo],

        components: {
            SaveStatus,
            EditDrawer,
            SprintDrawer,
            stageSelector,
            OpportunityDrawer,
            ConvertToStage3Drawer,
            UserstoryFiltersDrawer,
            UserstoryViewOptionsDrawer,
            UserstoryExportOptionsDrawer,
        },

        data: function () {
            return {
                loaded: false,
                members: [],
                presenceChannelName: ''
                //otherMembers: []
            }
        },

        computed: {
            ...mapState('settings/userstories', ['view_options', 'filters']),
            ...mapState('yodizproject', {
                project: 'single'
            }),
            ...mapState('epics', ['epics']),
            ...mapState('yodizproject/stages', {
                stage: 'single'
            }),

        	otherMembers () {
        		return this.members.filter((item) => {
					return item.id !== this.$user.id;
				})
        	},

            showSubMenu () {
                return find(this.$route.matched, ['name', 'projects.show.stage2']) != undefined
            },

            subMenuTitle () {
                if (this.$route.name == 'projects.show.stage2.userstories') {
                    return 'User Stories'
                } else if (this.$route.name == 'projects.show.stage2.deliverables') {
                    return 'Deliverables'
                } else if (this.$route.name == 'projects.show.stage2.schedule') {
                    return 'Schedule'
                } else if (this.$route.name == 'projects.show.stage2.quotes') {
                    return 'Quotes'
                }

                return ''
            },

            opportunityComponentForRoute() {
                if (find(this.$route.matched, ['name', 'projects.stage2.overview']) != undefined) {
                    return 'opportunity-drawer'
                }

                return ''
            },

            filterComponentForRoute() {
                if (find(this.$route.matched, ['name', 'projects.stage2.userstories']) != undefined) {
                    return 'userstory-filters-drawer'
                }

                return ''
            },

            viewOptionsComponentForRoute() {
                if (find(this.$route.matched, ['name', 'projects.stage2.userstories']) != undefined) {
                    return 'userstory-view-options-drawer'
                }

                return ''
            },

            exportOptionsComponentForRoute() {
                if (find(this.$route.matched, ['name', 'projects.stage2.userstories']) != undefined) {
                    return 'userstory-export-options-drawer'
                }

                return ''
            }
        },
        beforeRouteUpdate (to, from, next) {

            //Refresh stage data if user has navigated back to the overview
            if (to.name == 'projects.stage2.overview') {
                this.getStage(this.$route.params.stage_id)
            }

            next()
        },
        mounted: function() {
            var that = this;

            this.getYodizProject(this.$route.params.project_id).then(() => {
                this.getStage(this.$route.params.stage_id).then(() => {
                    this.loaded = true
                })
            });
        },
        async created () {

          this.echoConnect()

        	this.presenceChannelName = `channel-${this.$route.params.project_id}`

            this.echo.join(this.presenceChannelName)
            .here((users) => {
                this.members = users
            })
            .joining((user) => {
                this.members.push(user)
            })
            .leaving((user) => {
                for (var i=0;i<=this.members.length - 1;i++) {
                    if (this.members[i].id == user.id) {
                        this.members.splice(i, 1)
                    }
                }
            })
            .listen('Project.newEpicBroadcast', (data) => {
                //Ensure stories array exists on new epic / eager load in api isn't loading
                data.epic.stories = [];

                this[ADD_EPIC](data.epic)
            })
            .listen('Project.newUserStoryBroadcast', (data) => {

                if (data.story.creator_id !== this.$user.id) {

                    this[ADD_USERSTORY](data.story)
                }
            })
            .listen('Project.updateUserStoryBroadcast', (data) => {

                var epic = findIndex(this.epics, existing => existing.id === data.story.epic_id)

                if (epic !== -1) {
                    let storyIndex = findIndex(this.epics[epic].stories, existing => existing.id === data.story.id)

                    if (storyIndex >= 0) {
                        let propertyString = `epics.${epic}.stories.${storyIndex}`
                        this[SET_USERSTORY_PROPERTY]({ property: `${propertyString}.title`, value: data.story.title })
                        this[SET_USERSTORY_PROPERTY]({ property: `${propertyString}.description`, value: data.story.description })
                        this[SET_USERSTORY_PROPERTY]({ property: `${propertyString}.estimate`, value: data.story.estimate })
                        this[SET_USERSTORY_PROPERTY]({ property: `${propertyString}.complexity`, value: data.story.complexity })
                        this[SET_USERSTORY_PROPERTY]({ property: `${propertyString}.tech_notes`, value: data.story.tech_notes })
                        this[SET_USERSTORY_PROPERTY]({ property: `${propertyString}.test_notes`, value: data.story.test_notes })
                        this[SET_USERSTORY_PROPERTY]({ property: `${propertyString}.group_id`, value: data.story.group_id })
                        this[SET_USERSTORY_PROPERTY]({ property: `${propertyString}.tags`, value: data.story.tags })
                    }
                }
            })
            .listen('Project.lockUserStoryBroadcast', (data) => {
                var story = this.project.user_story_document.epics.find((item) => {
                    return item.id == data.story.epic_id
                }).stories.find((item) => {
                    return item.id == data.story.id
                })

                story.locked_by = data.story.locked_by;
                story.locked_at = data.story.locked_at;

            })
            .listen('Project.deleteUserStoryBroadcast', (data) => {
                this[REMOVE_USERSTORY](data.story)
            })
            .listen('Project.lockProjectNotesBroadcast', (data) => {
                this.project.user_story_document.locked_by = data.userStoryDocument.locked_by;
                this.$bus.$emit('notesLocked', data.userStoryDocument.locked_by != null);
            })
            .listen('Project.projectNotesUpdatedBroadcast', (data) => {
				this.project.user_story_document.notes = data.userStoryDocument.notes;
            })
            .listen('Project.projectCostingUpdatedBroadcast', (data) => {
				this.$bus.$emit('reload')
			}).listen('Project.newUserStoryGroupBroadcast', (data) => {
                this.addGroup(data.group)
            });
        },
        beforeDestroy: function() {
            this.echo.leave(this.presenceChannelName)
            this.echoDisconnect()
        },

        methods: {
          ...mapActions('groups', ['addGroup']),
          //...mapActions('project', ['getProject']),
          ...mapMutations('epics', [ADD_EPIC, ADD_USERSTORY, REMOVE_USERSTORY, SET_USERSTORY_PROPERTY]),

          ...mapActions('yodizproject', {
              getYodizProject: 'getSingle'
          }),

          ...mapActions('yodizproject/stages', {
              getStage: 'getSingle'
          }),

          async connectChannels () {
          },

        	getAvatar: function(id) {
        		return process.env.VUE_APP_API_URL + '/user/' + id + '/avatar';
            },

            openDrawer (ref) {
                if (this.$refs[ref]) {
                    this.$refs[ref].open()
                }
            }
        },

    }
</script>
